module.exports = __webpack_public_path__ + "static/media/RIGHT.f9ec1271.svg";